module.exports = __webpack_public_path__ + "img/20.acc9aad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/new_fair/20.png
// module id = 210
// module chunks = 1